import Api from '@common/services/api';

export const toggleNotifications = async (orgId: string, conversationId: string, mute: boolean) => {
  return Api.post(`/v3/organisations/${orgId}/conversations/${conversationId}/mute`, {
    mute_conversation: mute,
  });
};
